<template>
  <v-card
    class="pa-4 d-flex flex-column justify-space-between"
    height="150"
    min-width="310"
    max-width="600"
    outlined
  >
    <v-skeleton-loader type="text" width="270" class="mb-2" />
    <v-skeleton-loader type="paragraph" max-width="260" class="mb-3" />
    <v-skeleton-loader type="text" width="100" />
  </v-card>
</template>

<script>
export default {
  name: 'SkeletonCard',
}
</script>
